/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowLoopRight = createReactComponent("outline", "arrow-loop-right", "IconArrowLoopRight", [["path", { "d": "M12 21v-13a4 4 0 1 0 -4 4h13", "key": "svg-0" }], ["path", { "d": "M17 16l4 -4l-4 -4", "key": "svg-1" }]]);

export { IconArrowLoopRight as default };
//# sourceMappingURL=IconArrowLoopRight.mjs.map
